import { useSelector } from 'react-redux';
import type Context from '@alltrails/types/Context';

const useUserLocation = (): Context['userLocation'] => useSelector((state: { context: Context }) => state.context.userLocation);

export default useUserLocation;
